export type BuildHour = {
  dayIndex: string;
  endTime: string;
  startTime: string;
};

export type MenuType = 'takeout' | 'catering';

export type UploadMethod = 'file' | 'url';

export type Schedule = {
  dayIndex: string;
  endTime: string;
  isDeleted?: boolean;
  isPeriod?: boolean;
  startTime: string;
  tempId?: string;
  uuid?: string;
};

export type InfoErrors = {
  deliverySchedule?: string;
  menuName?: string;
  pickupSchedule?: string;
  taxRate?: string;
};

export type BuildStatus =
  | 'started'
  | 'file_uploaded'
  | 'file_processed'
  | 'menu_created'
  | 'menu_inserted'
  | 'finished'
  | 'failed';

export type BuildErrorKey =
  | 'bot_protection_detected'
  | 'no_menu_content_found'
  | 'url_invalid'
  | 'url_fetch_failed'
  | 'processing_failed';

export type BuildStatusResponse = {
  requestId: string;
  status: BuildStatus | null;
  errorKey?: BuildErrorKey | null;
  menuUuid?: string | null;
  companyId: number;
  merchantId: number;
  type: string;
};

export type BuildResponse = {
  jobId: string;
  status: BuildStatus;
};

export type ActiveBuildResponse = {
  jobId: string;
  status: BuildStatus;
  companyId: number;
  merchantId: number;
  menuName: string;
  type: string;
};

export const TERMINAL_BUILD_STATUSES: BuildStatus[] = ['menu_inserted', 'finished', 'failed'];

export type MenuBuildStep = 'processing' | 'importing' | 'creating' | 'finalizing';

export type StepState = 'done' | 'active' | 'pending' | 'error';
